<template>
    <tr class="lms__superadmin_users_list_table_item_collapse_table_item">
        <td class="lms__superadmin_users_list_table_item_collapse_table_item_customer">{{ profileCustomerName }}</td>
        <template v-if="profileWorkspaceId">
            <td class="lms__superadmin_users_list_table_item_collapse_table_item_workspace">
                <template v-if="user.isMasterAdministrator() && profileWorkspaceId !== loggedInUserWorkspaceId">
                    <component-button
                        :name="`lms-superadmin-users-list-table-item-collapse-table-item-${profileWorkspaceName}`"
                        :text="true"
                        :icon="true"
                        :icon-name="'arrow-right-circle'"
                        :icon-align="'right'"
                        :animate-loading="true"
                        :animate-loading-event-name="'switch-workspace'"
                        :tooltip-active="true"
                        :tooltip-position="'top'"
                        :tooltip-text="'Access workspace'"
                        @click="switchWorkspace(profileWorkspaceId)"
                    >{{ profileWorkspaceName }}
                    </component-button>
                </template>
                <template v-else>
                    {{ profileWorkspaceName }}
                </template>
            </td>
            <td class="lms__superadmin_users_list_table_item_collapse_table_item_roles">
                <component-badge-roles-list
                    v-if="profileRoles"
                    :roles="profileRoles"
                ></component-badge-roles-list>
            </td>
        </template>
        <td class="lms__superadmin_users_list_table_item_collapse_table_item_status">
            <component-status :status="profileStatus"/>
        </td>
        <td class="lms__superadmin_users_list_table_item_collapse_table_item_actions">
            <div class="columns is-vcentered">
                <div class="column"></div>
                <template v-if="profileWorkspaceId">
                    <div class="column is-narrow">
                        <component-button
                            :name="'lms-superadmin-users-list-table-item-collapse-table-item-edit'"
                            :theme="'default'"
                            @click="performRedirectToEdit"
                        >Edit
                        </component-button>
                    </div>
                </template>
                <div v-if="listMenuButtons.length" class="column is-narrow">
                    <component-button-menu
                        :name="'lms-superadmin-users-list-table-item-collapse-table-item-actions-menu'"
                        :buttons="listMenuButtons"
                        @emit-login-as-learner="performEmit('emit-login-as-learner', userProfileId)"
                        @emit-resend-invitation="performEmit('emit-resend', userProfileId)"
                        @emit-cancel-invitation="performEmit('emit-cancel', userProfileId)"
                        @emit-delete-profile="performEmit('emit-delete-profile', userProfileId)"
                        @emit-reactivate-profile="performEmit('emit-reactivate-profile', { id: userProfileId, status: userProfileStatus})"
                    ></component-button-menu>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
import ComponentStatus from '@/components/default/shared/ComponentStatus'
import { User } from '@/User'
import ComponentButtonMenu from '@/components/default/shared/ComponentButtonMenu'
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentBadgeRolesList from '@/components/default/shared/ComponentBadgeRolesList'

export default {
  name: 'lms-superadmin-users-list-table-item-collapse-table-item',
  components: { ComponentBadgeRolesList, ComponentButton, ComponentButtonMenu, ComponentStatus },
  data () {
    return {
      user: new User()
    }
  },
  props: {
    item: {
      type: Object
    },
    invitations: {
      type: Array
    }
  },
  computed: {
    userProfilesWorkspaceIds () {
      return this.$store.getters.getLmsSuperadminUserProfilesWorkspaceIds
    },
    loggedInUserWorkspaceId () {
      return this.$store.getters.getAuthUserSecondStageTokenDataWorkspaceId
    },
    userProfileId () {
      return this.item.id
    },
    userProfileStatus () {
      return this.item.status
    },
    userId () {
      return this.item.userId
    },
    profileCustomerName () {
      return this.item.customerName
    },
    profileWorkspaceName () {
      return this.item.workspaceName
    },
    profileWorkspaceId () {
      return this.item.workspaceId
    },
    profileRoles () {
      return this.item.roles
    },
    profileIsLearner () {
      const roles = JSON.parse(JSON.stringify(this.item.roles))
      return roles.includes('learner')
    },
    profileStatus () {
      return this.item.status
    },
    listMenuButtons () {
      const buttonsArr = []

      if (
        (
          !this.user.hasSelectedProfile() &&
      this.user.isSuperadmin() &&
      this.profileIsLearner &&
      this.profileStatus === 'active' &&
      this.userId !== this.user.userId
        ) ||
      (
        this.user.hasSelectedProfile() &&
      this.user.isUserAdministrator() &&
      this.profileIsLearner &&
      this.profileStatus === 'active' &&
      this.profileWorkspaceId === this.loggedInUserWorkspaceId
      )
      ) {
        buttonsArr.push({
          name: 'Login as learner',
          key: 'login-as-learner'
        })
      }
      if (this.profileStatus === 'invited' || this.profileStatus === 'rejected' || this.profileStatus === 'cancelled' || this.profileStatus === 'sent') {
        if (buttonsArr && buttonsArr.length) {
          buttonsArr.push({
            name: '',
            key: '',
            blank: true
          })
        }
        buttonsArr.push({
          name: 'Resend invitation',
          key: 'resend-invitation',
          icon: true,
          iconName: 'mail'
        })
      }
      if (this.profileStatus === 'invited' || this.profileStatus === 'sent') {
        if (buttonsArr && buttonsArr.length) {
          buttonsArr.push({
            name: '',
            key: '',
            blank: true
          })
        }
        buttonsArr.push({
          name: 'Cancel invitation',
          key: 'cancel-invitation',
          icon: true,
          iconName: 'x-circle'
        })
      }
      if (this.profileStatus === 'active') {
        if (buttonsArr && buttonsArr.length) {
          buttonsArr.push({
            name: '',
            key: '',
            blank: true
          })
        }
        buttonsArr.push({
          name: 'Delete profile',
          key: 'delete-profile',
          icon: true,
          iconName: 'trash-2',
          danger: true
        })
      }
      if (this.profileStatus === 'deleted' || this.profileStatus === 'expired') {
        if (buttonsArr && buttonsArr.length) {
          buttonsArr.push({
            name: '',
            key: '',
            blank: true
          })
        }
        buttonsArr.push({
          name: 'Re-activate profile',
          key: 'reactivate-profile',
          icon: true,
          iconName: 'refresh-ccw'
        })
      }

      return buttonsArr
    }
  },
  methods: {
    switchWorkspace (data) {
      this.$eventBus.$emit('trigger-loading-users')
      this.$store.dispatch('authUserLoginSSOWorkspace', data).then(() => {
        this.$store.dispatch('defaultNotificationToastsAdd', {
          title: 'Workspace accessed',
          status: 'success'
        })
      }).catch(() => {
        this.$store.dispatch('defaultNotificationToastsAdd', {
          title: 'Workspace not accessed',
          message: 'There is a problem accessing this workspace. Please check you have access to this workspace.',
          status: 'error'
        })
      }).finally(() => {
        this.$eventBus.$emit('stop-switch-workspace')
        this.$eventBus.$emit('trigger-get-users')
      })
    },
    performEmit (message, value) {
      this.$emit('emit', { message: message, value: value })
    },
    performRedirectToEdit () {
      this.$router.push({ name: 'lms-superadmin-user-profile-edit', params: { userId: this.userId, profileId: this.userProfileId } })
    },
    performEmitResendInvitation () {
      this.performEmit('emit-resend', this.userProfileId)
    },
    performEmitCancelInvitation () {
      this.performEmit('emit-cancel', this.userProfileId)
    }
  }
}
</script>
